import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { Apollo, Mutation } from "apollo-angular";
import { DeleteIndicatorCalculationDto } from "src/app/service/IndicatorCalculation.service";

export type DeleteIndicatorCalculationMutationVariables = {
  id: DeleteIndicatorCalculationDto;
};

export type DeleteIndicatorCalculationMutation = {
  deleteIndicatorCalculation: boolean;
};


export const DeleteIndicatorCalculationDocument = gql`
  mutation DeleteIndicatorCalculation($id: DeleteIndicatorCalculationDto!) {
    deleteIndicatorCalculation(id: $id)
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteIndicatorCalculationGQL extends Mutation<
  DeleteIndicatorCalculationMutation,
  DeleteIndicatorCalculationMutationVariables
> {
  document = DeleteIndicatorCalculationDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
